export const G5_DEVICE_GENERATION = 1;

const normalizeLabel = (label) =>
  String(label || '')
    .trim()
    .toLowerCase();

export const getUltraGenerationOption = (generationOptions = []) =>
  generationOptions.find((option) => normalizeLabel(option.label) === 'ultra');

export const isUltraGenerationValue = (value, generationOptions = []) => {
  const ultraOption = getUltraGenerationOption(generationOptions);
  return ultraOption != null && String(ultraOption.value) === String(value);
};

// The database exposes Ultra as a separate installation choice, while sensors
// are still stored as G5 devices with the isMini flag set.
export const getGenerationFormValue = (sensor, generationOptions = []) => {
  const ultraOption = getUltraGenerationOption(generationOptions);

  if (sensor && Number(sensor.isMini) === 1 && ultraOption != null) {
    return ultraOption.value;
  }

  return sensor ? sensor.DeviceGenerationValue : undefined;
};

export const normalizeGenerationForApi = (values, generationOptions = []) => {
  if (!values) return values;

  const isUltra =
    isUltraGenerationValue(values.DeviceGenerationValue, generationOptions) ||
    (Number(values.DeviceGenerationValue) === G5_DEVICE_GENERATION &&
      Number(values.isMini) === 1);

  return {
    ...values,
    DeviceGenerationValue: isUltra
      ? G5_DEVICE_GENERATION
      : values.DeviceGenerationValue,
    isMini: isUltra ? 1 : 0,
  };
};
